var _rect, _rect2, _rect3, _path, _rect4, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#CFD3E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#CFD3E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#AEB6CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.832 20.0835H24.1654C20.6654 20.0835 18.332 21.8335 18.332 25.9168V34.0835C18.332 38.1668 20.6654 39.9168 24.1654 39.9168H35.832C39.332 39.9168 41.6654 38.1668 41.6654 34.0835V25.9168C41.6654 21.8335 39.332 20.0835 35.832 20.0835ZM20.3737 25.9168C20.3737 23.8285 22.077 22.1252 24.1654 22.1252H25.9154C26.3937 22.1252 26.7904 22.5218 26.7904 23.0002C26.7904 23.4785 26.3937 23.8752 25.9154 23.8752H24.1654C23.0454 23.8752 22.1237 24.7968 22.1237 25.9168V27.6668C22.1237 28.1452 21.727 28.5418 21.2487 28.5418C20.7704 28.5418 20.3737 28.1452 20.3737 27.6668V25.9168ZM25.9154 37.8752H24.1654C22.077 37.8752 20.3737 36.1718 20.3737 34.0835V32.3335C20.3737 31.8552 20.7704 31.4585 21.2487 31.4585C21.727 31.4585 22.1237 31.8552 22.1237 32.3335V34.0835C22.1237 35.2035 23.0454 36.1252 24.1654 36.1252H25.9154C26.3937 36.1252 26.7904 36.5218 26.7904 37.0002C26.7904 37.4785 26.3937 37.8752 25.9154 37.8752ZM29.9987 33.5002C28.062 33.5002 26.4987 31.9368 26.4987 30.0002C26.4987 28.0635 28.062 26.5002 29.9987 26.5002C31.9354 26.5002 33.4987 28.0635 33.4987 30.0002C33.4987 31.9368 31.9354 33.5002 29.9987 33.5002ZM39.6237 34.0835C39.6237 36.1718 37.9204 37.8752 35.832 37.8752H34.082C33.6037 37.8752 33.207 37.4785 33.207 37.0002C33.207 36.5218 33.6037 36.1252 34.082 36.1252H35.832C36.952 36.1252 37.8737 35.2035 37.8737 34.0835V32.3335C37.8737 31.8552 38.2704 31.4585 38.7487 31.4585C39.227 31.4585 39.6237 31.8552 39.6237 32.3335V34.0835ZM39.6237 27.6668C39.6237 28.1452 39.227 28.5418 38.7487 28.5418C38.2704 28.5418 37.8737 28.1452 37.8737 27.6668V25.9168C37.8737 24.7968 36.952 23.8752 35.832 23.8752H34.082C33.6037 23.8752 33.207 23.4785 33.207 23.0002C33.207 22.5218 33.6037 22.1252 34.082 22.1252H35.832C37.9204 22.1252 39.6237 23.8285 39.6237 25.9168V27.6668Z",
    fill: "#0D236E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#00B96B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.168 50.5832L59.8346 38.9165",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.168 42.0254V50.5837H56.7263",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.918 54.3335H61.0846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.590078bd48a1d53ab5a40ae74fd936fa.svg";
export { ForwardRef as ReactComponent };